import { render, staticRenderFns } from "./routingList.vue?vue&type=template&id=c0e23128&"
import script from "./routingList.vue?vue&type=script&lang=js&"
export * from "./routingList.vue?vue&type=script&lang=js&"
import style0 from "./routingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports